import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import { formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@asadoxperience.com");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success("Bienvenido");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail) || err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 relative overflow-hidden" data-testid="admin-login-page">
      <div className="absolute inset-0 bg-gradient-to-br from-charred via-[#0d0a07] to-charred" />
      <div className="absolute inset-0 grain opacity-50" />
      <div className="relative w-full max-w-md border border-white/10 bg-surface/60 backdrop-blur p-10">
        <Link to="/" className="inline-flex items-center gap-3 mb-10" data-testid="admin-login-logo">
          <span className="relative inline-flex h-7 w-7 items-center justify-center border border-ember/60">
            <span className="absolute h-[2px] w-4 bg-ember rotate-45"></span>
            <span className="absolute h-[2px] w-4 bg-ember -rotate-45"></span>
          </span>
          <span className="font-display text-base tracking-[0.28em] uppercase">
            Asado <span className="text-ember">Xperience</span>
          </span>
        </Link>
        <span className="overline flex items-center gap-3"><span className="divider-gold" />Admin</span>
        <h1 className="font-display text-4xl mt-4 text-[#F5F3F0]">Ingresar al panel</h1>

        <form onSubmit={submit} className="mt-10 space-y-6">
          <label className="block">
            <span className="overline block mb-2">Email</span>
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-transparent border-b border-white/20 text-[#F5F3F0] py-3 focus:outline-none focus:border-ember"
              data-testid="admin-email-input" />
          </label>
          <label className="block">
            <span className="overline block mb-2">Contraseña</span>
            <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-transparent border-b border-white/20 text-[#F5F3F0] py-3 focus:outline-none focus:border-ember"
              data-testid="admin-password-input" />
          </label>
          <button type="submit" disabled={submitting} className="btn-primary w-full" data-testid="admin-login-btn">
            <Lock size={14} /> {submitting ? "..." : "Ingresar"}
          </button>
        </form>
      </div>
    </div>
  );
}
